<template>
	<div class="inner-modal inner-modal--acc">
		<div class="acc">
			<div class="acc__inner">
				<div class="acc__form">
					<div class="acc__head">
						<h3 class="acc__heading">Create a New Account</h3>
						<p>Creating an account lets you save your wishlist and open them on other devices such as your phone.</p>
						<template v-if="validationErrors.length">
							<template v-for="error in validationErrors">
								<p class="text-danger">{{error}}</p>
							</template>
						</template>
					</div>
					<div class="form-group">
						<label for="emailAddress">Email address<span class="text-danger">*</span></label>
						<input type="email" v-model="registrationInfo.emailAddress" id="emailAddress" :class="[`form-control`, formValidationErrors?.emailAddress?.length ? 'is-invalid' : '']">
						<div class="invalid-feedback" v-for="error in formValidationErrors?.emailAddress">
							&bull; {{error}}
						</div>
					</div>
					<div class="form-group">
						<label for="password">Password<span class="text-danger">*</span></label>
						<input type="password" v-model="registrationInfo.password" id="password" :class="[`form-control`, formValidationErrors?.password?.length ? 'is-invalid' : '']">
						<div class="invalid-feedback" v-for="error in formValidationErrors?.password">
							&bull; {{error}}
						</div>
					</div>
					<div class="form-group">
						<label for="confirmPassword">Confirm Password<span class="text-danger">*</span></label>
						<input type="password" v-model="registrationInfo.confirmPassword" class="form-control" id="confirmPassword" :class="[`form-control`, formValidationErrors?.confirmPassword?.length ? 'is-invalid' : '']">
						<div class="invalid-feedback" v-for="error in formValidationErrors?.confirmPassword">
							&bull; {{error}}
						</div>
					</div>
					<div class="text-center mt-3">
						<Cta type="primary" size="lg" label="Create" @onClick="create" :icon="[]" iconAlignment="left"> </Cta>
					</div>
				</div>
				<div class="acc__more">
					<Cta type="outline" size="lg" label="Login" @onClick="login" :icon="[]" iconAlignment="left"> </Cta>
					<Cta type="outline" size="lg" label="Forgot Password" @onClick="forgotPassword" :icon="[]" iconAlignment="left"> </Cta>
				</div>
			</div>
		</div>
		<button @click="closeModal" class="inner-modal__close">&times;</button>
	</div>
</template>

<script lang="ts" setup>
import {computed, ref} from 'vue';
const componentName = 'AccountRegistrationModal';
import { useStore } from 'vuex';
import Cta from "Vue/components/lockDesigner/components/shared/Cta.vue";
import {UserRegister} from "Api/apis";
const store = useStore();
import { useRouter } from 'vue-router';
const router = useRouter();
const validationErrors = ref<string[]>([]);
const formValidationErrors = ref<any>({});

const props = defineProps({
	forwardingRoute: String,
	closeModal: Boolean,
	pathPrefix: String
});

const registrationInfo = ref<{ emailAddress: string, password: string, confirmPassword: string }>({
	emailAddress: "",
	password: "",
	confirmPassword: "",
});

const create = async () => {
	await UserRegister(registrationInfo.value).then(async(response) => {
		if(response.data) {
			await store.commit('updateAuthToken', response.data.authToken);
			await router.push(props.forwardingRoute);
			if(props.closeModal) {
				await store.dispatch('closeModal');
			}
		} else {
			if(response.isErrors) {
				if(response.errorDetail.isError) {
					validationErrors.value = response.userFriendlyMessages;
				}
				if(response.formValidationMessages) {
					formValidationErrors.value = response.formValidationMessages;
				}
			}
		}
	});
};

const login = async() => {
	await router.push(`${props.pathPrefix}/login`);
};

const forgotPassword = async() => {
	await router.push(`${props.pathPrefix}/forgot-password`);
};


const closeModal = async() => {
	await store.dispatch('closeModal');
};
</script>
